<template>
    <auth-box :logo="false" class="max-w-[480px]">
        <div class="flex flex-col gap-4">
            <div class="text-xl font-extrabold" data-test="no-access-title">No access to {{ teamName }} yet</div>
            <div class="text-sm text-slate-500" data-test="no-access-message">
                <template v-if="FEATURES.contact_groups">
                    An administrator still has to add you to an Organizational Unit or Group, or give you a role.
                </template>
                <template v-else>An administrator still has to give you a role.</template>
            </div>
            <div class="text-sm text-slate-500">
                Waiting on another team? Switch teams from the menu or check your
                <a href="/settings#/invites" data-test="no-access-invites">pending invitations</a>.
            </div>
            <vx-button href="/logout" color="muted-light" data-test="no-access-logout">Logout</vx-button>
        </div>
    </auth-box>
</template>

<script lang="ts" setup>
import { inject } from 'vue';
import { VxButton } from '@voxie/frontend-components';
import AuthBox from '~/components/auth/AuthBox.vue';
import type { Features } from '~/provides/features.types';

const FEATURES = inject('FEATURES') as Features;

const teamName = Spark.state.currentTeam.name;

if (Spark.state.user.has_context_access) {
    window.location.assign('/');
}
</script>
